import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const vehicleDetailsApi = createApi({
  reducerPath: 'vehicleDetailsApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['vehicleCategory'],
  endpoints: (builder) => ({
    
    saveVehicleDetails: builder.mutation({
      query(body) {
        return {
          url: spotFinder.VehicleDetailsController.saveVehicleDetails,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateVehicleDetails: builder.mutation({
      query(body) {
        console.log(body.payload?.id ,"body.payload?.id");
        return {
          url: `${spotFinder.VehicleDetailsController.updateVehicleDetails}/${body.payload?.id}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    })
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSaveVehicleDetailsMutation, useUpdateVehicleDetailsMutation
} = vehicleDetailsApi;
